import React from 'react';
import styled from 'styled-components';
import { _ } from '_locales';

const TextContainer = styled.div`
    width: 100%;
    height: 150px;
    position: relative;
    background-color: transparent;
    text-align: center;
`;

const Text = styled.p`
     
    font-size: 16px !important;
    color: #6F6F6F;
    font-weight: 500 !important;
    text-align: left;
    line-height: 1.5em;
    margin-top: 10px;
`;

const NotFound = () => (
  <TextContainer role="alert">
    <Text>{_('general.no_address_found')}</Text>
  </TextContainer>
);

export default NotFound;
